//AssetsSection
import React, { useState } from "react";
import { Row, Col, Card, Button, Select, } from "antd";
import { EditOutlined } from '@ant-design/icons';
import ModalEditAsset from "../modals/ModalEditAsset";

// ========================= Component หลัก =========================
const AssetsSection = ({ people, provinces, datas, handleLoadEdit }) => {
    const [openModalEdit, setOpenModalEdit] = useState(false); // แก้ไข
    const [dataForEdit, setdataForEdit] = useState(false);
    const [indes, setIndes] = useState();

    // console.log("assetsRadioState", assetsRadioState);
    // console.log("handleLoadEdit", handleLoadEdit);
    // console.log("people", people);
    // console.log("datas", datas);

    return (
        <>
            <Row justify={'center'} gutter={[16, 16]} style={{ height: "700px" }}>
                {people?.map((g, indexs) => {
                    return (
                        <Col key={`${indexs}`} xs={24} sm={24} md={12} lg={8}>
                            <Card
                                type="inner"
                                title={
                                    <div style={{ textAlign: "center", width: "100%", fontWeight: "600", fontSize: "18px" }}>
                                        {g?.role === 0 ? "👤 คนกู้" : `🤝 คนค้ำ (${indexs})`}
                                    </div>
                                }
                                style={{
                                    width: "100%",
                                    borderRadius: "16px",
                                    border: "none",
                                    boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                                    overflow: "hidden"
                                }}
                                actions={[

                                    <Button
                                        type="text"
                                        icon={<EditOutlined />}
                                        onClick={() => {
                                            setdataForEdit(g);
                                            setIndes(indexs);
                                            setOpenModalEdit(true);
                                        }}
                                        style={{
                                            borderRadius: "8px",
                                            background: "gray",
                                            color: "white"
                                        }}
                                    >
                                        ทรัพย์สิน
                                    </Button>
                                ]}
                            >
                                <p><strong>ชื่อ - สกุล:</strong> {g?.snam || "-"} {g?.name1 || "-"} {g?.name2 || "-"} </p>
                                <p><strong>สถานะทรัพย์ : </strong>
                                    {g?.investigation === true ?
                                        <b style={{ color: g?.investigation === true ? "green" : "red" }}> มีทรัพย์</b>
                                        : g?.investigation === false ?
                                            <b style={{ color: g?.investigation === true ? "green" : "red" }}> ไม่มีทรัพย์</b>
                                            : g?.investigation === null ?
                                                <b style={{ color: g?.investigation === true ? "green" : "orange" }}> ยังไม่ได้เพิ่มทรัพย์</b>
                                                : null
                                    }
                                </p>
                            </Card>
                        </Col>
                    );
                })}
            </Row>
            {
                openModalEdit ?
                    <ModalEditAsset
                        open={openModalEdit}
                        onClose={setOpenModalEdit}
                        index={indes}
                        dataForEdit={dataForEdit}
                        provinces={provinces}
                        handleLoadEdit={handleLoadEdit}
                        datas={datas}
                    />
                    : null
            }
        </>
    );
}

export default AssetsSection;
